import React from "react";

import { ScrollablePane, Stack, useTheme } from "@bps/fluent-ui";
import { SectionTitle } from "@components/SectionTitle";
import {
  FieldDevice,
  FieldDeviceProperty
} from "@libs/api/gateways/field/field-ops-gateway.dtos";
import { useFieldDeviceProperties } from "@libs/api/gateways/field/field-ops-gateway.hooks";

import { ConnectivityBadge } from "./ConnectivityBadge";
import {
  DeviceConnectivityTable,
  OverviewTableItem
} from "./DeviceConnectivityTable";

interface FieldDeviceConnectivityProps {
  device: FieldDevice;
}

export const FieldDeviceConnectivity: React.FC<FieldDeviceConnectivityProps> = ({
  device
}) => {
  const theme = useTheme();
  const { data, isLoading } = useFieldDeviceProperties(device.id);

  return (
    <>
      <SectionTitle>Device Connectivity</SectionTitle>

      <Stack tokens={{ childrenGap: theme.spacing.s1 }}>
        <ScrollablePane
          styles={{ root: { position: "relative", height: 400, width: "80%" } }}
        >
          <DeviceConnectivityTable
            items={getOverviewItems(device, data!) ?? []}
            isLoading={isLoading}
          />
        </ScrollablePane>
      </Stack>
    </>
  );
};

export function getOverviewItems(
  fieldDevice: FieldDevice,
  properties?: FieldDeviceProperty[]
) {
  return [
    {
      Name: "BlobStorage",
      Value: (
        <ConnectivityBadge
          property={properties?.find(
            p => p.propertyType === "HealthStatus_BlobStorage"
          )}
        />
      )
    },
    {
      Name: "CDN",
      Value: (
        <ConnectivityBadge
          property={properties?.find(
            p => p.propertyType === "HealthStatus_CDN"
          )}
        />
      )
    },
    {
      Name: "FieldGatewayApi",
      Value: (
        <ConnectivityBadge
          property={properties?.find(
            p => p.propertyType === "HealthStatus_FieldGatewayApi"
          )}
        />
      )
    },
    {
      Name: "FieldManagementApi",
      Value: (
        <ConnectivityBadge
          property={properties?.find(
            p => p.propertyType === "HealthStatus_FieldManagementApi"
          )}
        />
      )
    },
    {
      Name: "PremierDatabase",
      Value: (
        <ConnectivityBadge
          property={properties?.find(
            p => p.propertyType === "HealthStatus_PremierDatabase"
          )}
        />
      )
    },
    {
      Name: "SignalR",
      Value: (
        <ConnectivityBadge
          property={properties?.find(
            p => p.propertyType === "HealthStatus_SignalR"
          )}
        />
      )
    }
  ] as OverviewTableItem[];
}
